module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-1.e8547c69.svg";